import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import { useAppContext } from "./context/AppContext";

import { HomePage } from "./pages/HomePage";
import { BookingTestPage } from "./pages/BookingTestPage";

import { ModalProvider } from "./providers/ModalProvider";

const App = () => {
  const { isLoggedIn, setIsLogin } = useAppContext();
  const [isAskIrisVisible, setIsAskIrisVisible] = useState(false);

  useEffect(() => {
    const storedLogin = localStorage.getItem("iris-portal-signed");
    const email = localStorage.getItem("iris-portal-signed-email");

    if (storedLogin === "true" && !!email) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [setIsLogin]);

  useEffect(() => {
    const askIrisSection = document.getElementById("trigger");

    if (!askIrisSection) return;

    const handleScroll = () => {
      const askIrisRect = askIrisSection.getBoundingClientRect();

      const isPastAskIris = askIrisRect.top <= 0;

      if (isPastAskIris) {
        if (!isAskIrisVisible) setIsAskIrisVisible(true);
      } else {
        if (isAskIrisVisible) setIsAskIrisVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAskIrisVisible]);

  return (
    // <React.Fragment>
    //   {!isLoggedIn ? (
    //     <LoginCard />
    //   ) : (
    //     <div className="iris-container-page">
    //       <NavigationBlock />
    //       <HeroSectionBlk />

    //       <div id="icxeed-difference">
    //         <TabSectionBlk title="iCXeed Difference" tabs={icxeedDifference} />
    //       </div>

    //       <div id="clientele-verticals">
    //         <TabSectionBlk
    //           title="Clientele & Verticals"
    //           tabs={clientVertical}
    //         />
    //       </div>

    //       <div id="use-cases">
    //         <UseCasesSectionBlk
    //           title="Use Cases / Battlecards"
    //           description="Explore iCXeed's essential battlecards - a curated set of use cases, best practice guides, and rapid-deployment solutions for CX, Contact Centre, and AI transformation."
    //           videoBg={true}
    //         />
    //         <CardSliderSectionBlk
    //           cards={(useCasesCards ?? []).map((c) => ({
    //             ...c,
    //             image: c.image ?? "",
    //           }))}
    //         />

    //         <UseCasesSectionBlk
    //           title="Case Studies"
    //           description="See the impact, from rapid implementations to scalable innovation, across diverse sectors and challenges "
    //           videoBg={false}
    //         />
    //         <CardSliderCaseStudies cards={useCaseCard ?? []} />

    //         <VideosAndDemosSection />
    //       </div>

    //       <div id="client-testimonials">
    //         <TestimonialSectionBlk
    //           testimonials={testimonials}
    //           title="Client Testimonials"
    //           isPaused={isAskIrisVisible}
    //         />
    //         <TestimonialSectionBlk
    //           testimonials={testimonialsAws}
    //           title="AWS Testimonials"
    //           isPaused={isAskIrisVisible}
    //         />
    //       </div>
    //       <div id="trigger"></div>
    //       <div id="key-contacts">
    //         <KeyContactsSectionBlk />
    //         <AccordionSectionBlk />
    //       </div>

    //       <div id="ask-iris">
    //         <AskIrisSectionBlk />
    //       </div>

    //       <IrisChatBotBlk />

    //       <FooterPage />

    //       <BookButton />

    //       <ModalProvider />
    //     </div>
    //   )}
    // </React.Fragment>

    <BrowserRouter>
      <ModalProvider />
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              isLoggedIn={isLoggedIn}
              isAskIrisVisible={isAskIrisVisible}
            />
          }
        />
        <Route path="/book-a-meeting-test-page" element={<BookingTestPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
